export default "__VITE_ASSET__CKjqEFFL__"